export default "__VITE_ASSET__eb4798b0__"